<template>
	<div class="conteudo-sistema">
		<!-- <iframe v-for="(client, i) in clientList" :id="client.id" :src="client.linkProducao"
			style="position: absolute; width:0; height:0; border:0;"></iframe> -->
		<div class="fl-cabecalho">
			<div class="row animated slideInDown">
				<div class="col-9 form-group">
					<h4 class="animated slideInDown"><fa-icon icon="users" /> Clientes</h4>
				</div>
			</div>

			<div class="row animated slideInDown">
				<div class="col-lg-4 col-12 col-xs-12 form-group">
					<flFind @key-up="(inputText) => $refs.table.filtraLista(inputText)" placeholder="Buscar" />
				</div>
				<div class="col-12 col-xs-12 col-lg-2 form-group">
					<button v-if="_getPrivilegio(2)" @click="clickModal(null)"
						class="btn btn-sm btn-block btn-outline-dark">
						<fa-icon icon="plus" /> Novo
					</button>
				</div>
			</div>
		</div>

		<flCarregando style="margin-top:20px" v-if="load" />

		<fl-table class="animated fadeIn fast" v-show="!load" ref="table" :perPage="10" @click-editar="clickModal"
			columnStartSortable="nome" :columns="geraCabecalhos()" />

		<flModal @modal-hide="showForm = false" ref="modalCadastro" width="60%">
			<template v-slot:header>
				<span v-if="editar"><fa-icon icon="pen-alt" /> Editar</span>
				<span v-if="!editar"><fa-icon icon="plus" /> Novo</span>
			</template>
			<flCadastro v-if="showForm" :timezones="timezones" ref="cadastro" @item-salvo="atualizaItem" />
		</flModal>

	</div>
</template>


<script>
import flCadastro from './cadastro.vue'
import flTable from '../../components/table/main.vue'
import flModal from '../../components/modal/main.vue'
import flCarregando from '../../components/carregando/main.vue'
import { mapState, mapActions } from 'vuex'
import axios from '../../routers/axios'
import flFind from '../../components/find/main.vue'
export default {

	components: {
		flCadastro,
		flTable,
		flModal,
		flCarregando,
		flFind
	},


	data() {
		return {
			load: false,
			showForm: false,
			editar: false,
			clientList: []
		}
	},

	computed: {
		...mapState({
			timezones: state => state.cliente.timezones,
			clientes: state => state.cliente.list,

		}),
	},

	mounted() {
		this.carregaDados()
	},

	updated() {
	//	this.test()
	},

	methods: {

		...mapActions(['setTimezones', 'setList', 'updateCliente']),

		clickModal(item) {

			this.editar = item ? true : false
			this.showForm = true
			this.$refs.modalCadastro.show()
			this.$nextTick(() => {
				if (this.editar) this.$refs.cadastro.carregaDados(item._object)
			})
		},

		test() {
			var doc = {}
			for (let i = 0; i < this.clientList.length; i++) {
				 doc = document.getElementById(this.clientList[i].id)
				if (doc)
					doc.contentWindow.postMessage(sessionStorage.getItem('_POLICE_SESSION_'), "*");
				
				doc = {}
			}

			this.iniciaBuscaDados()
		},

		iniciaBuscaDados() {
			setTimeout(() => {
				this.test()
			}, 5000)
		},

		atualizaItem(item) {
			this.updateCliente(item)
			this.$notify.show('success', 'Cliente salvo.')
			item = this.geraColunas(item)
			this.$refs.table.atualizaItem(item, 'id', item._object.id)
			this.exibeCadastro = false
			this.$refs.modalCadastro.hide()
		},

		carregaDados() {
			if (this.clientes.length == 0) {
				this.load = true
				axios.get(this._getUrl('api/cliente/GetListaAtivos')).then(response => {
					this.load = false

					for (let i = 0; i < response.data.length; i++) {
						if (response.data[i].linkProducao != null)
							this.clientList.push(response.data[i])
					}
					this.setList(response.data)
					this.listaClientes(response.data)
				})
			} else {
				this.listaClientes(this.clientes)
			}

			if (this.timezones.length == 0) {
				axios.get(this._getUrl('api/timezone')).then(response => {
					this.setTimezones(response.data)
				})
			}
		},

		listaClientes(list) {
			this.$refs.table.loadTable(list.map(item => { return this.geraColunas(item) }))
		},

		geraColunas(item) {
			let itemLista = {}
			let columns = []

			// id
			columns.push({ value: item.id })

			// nome
			columns.push({ value: item.nome })

			// ambientes
			columns.push({
				class: 'text-center',
				clickable: true,
				link: item.linkTeste != null && item.linkTeste != '' ? item.linkTeste : null,
				html: item.linkTeste != null && item.linkTeste != '' ? 'IR' : null,
				target: "_blank",
				icon: item.linkTeste != null && item.linkTeste != '' ? ["fa", "external-link-alt"] : null,
				styleIcon: 'font-size: 0.9rem',
			})

			columns.push({
				class: 'text-center',
				clickable: true,
				target: "_blank",
				link: item.linkHomologacao != null && item.linkHomologacao != '' ? item.linkHomologacao : null,
				html: item.linkHomologacao != null && item.linkHomologacao != '' ? 'IR' : null,
				icon: item.linkHomologacao != null && item.linkHomologacao != '' ? ["fa", "external-link-alt"] : null,
				styleIcon: 'font-size: 0.9rem',
			})

			columns.push({
				class: 'text-center',
				clickable: true,
				target: "_self",
				link: item.linkProducao != null && item.linkProducao != '' ? item.linkProducao : null,
				html: item.linkProducao != null && item.linkProducao != '' ? 'IR' : null,
				icon: item.linkProducao != null && item.linkProducao != '' ? ["fa", "external-link-alt"] : null,
				styleIcon: 'font-size: 0.9rem',
			})

			// se tiver o provilegio o botão de editar
			if (this._getPrivilegio(2)) {
				columns.push({
					class: 'text-center',
					clickable: true,
					event: 'click-editar',
					icon: ["fa", "pen-alt"],
					styleIcon: 'font-size: 0.9rem',
				})
			}

			itemLista._object = item
			itemLista.columns = columns
			return itemLista
		},

		geraCabecalhos() {

			let columns = []

			columns.push({
				name: 'Código',
				key: 'id',
				searchable: true,
				sortable: true,
				width: '8%',
			})

			columns.push({
				name: 'Nome',
				key: 'nome',
				searchable: true,
				sortable: true,
				width: '40%',
			})

			columns.push({
				name: 'Teste',
				key: 'teste',
				searchable: false,
				sortable: false,
				class: 'text-center',
				width: '10%',
			})

			columns.push({
				name: 'Homolog',
				key: 'homolog',
				searchable: false,
				sortable: false,
				class: 'text-center',
				width: '10%',
			})

			columns.push({
				name: 'Produção',
				key: 'producao',
				searchable: false,
				sortable: false,
				class: 'text-center',
				width: '10%',
			})

			if (this._getPrivilegio(3)) {
				columns.push({
					name: 'Editar',
					key: 'editar',
					searchable: false,
					sortable: false,
					class: 'text-center',
					width: '8%',
				})
			}

			return columns
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/views/cliente/main.vue